var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-content',[_c('h1',[_vm._v("Welcome to Stringy")]),_c('h2',[_vm._v("simple utilities for obscure usecases")]),_c('WordCount')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }